export default "__VITE_ASSET__5b256ebd__"